import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import DateRangeFilterWithSubmit from '../components/DateRangeFilterWithSubmit';
import SecondaryFilter from '../components/SecondaryFilter';
import SalesSummaryReportSet from '../components/SalesSummaryReportSet';
import SalesSummaryBihourlyReportSet from '../components/SalesSummaryBihourlyReportSet';
import ReportHeaderState from '../components/ReportHeaderState';
import NoAccess from '../noAccess';
import {RESOURCES as filterResources} from '../fuseFiltersResourceMap';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/editor/pie-chart';

export const fuseSalesSummaryReportsIcon = Icon;

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
};

/**
 * Sales Summary Reports class for retrieving and displaying summary
 *
 */
export class SalesSummaryReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            bihourlyDataProcessed: false,
            bihourlySummariesComplete: false,
            dataProcessed: false,
            isFilterReadyToSubmit: false,
            filterChoiceFirst: null,
            filterChoiceSecond: null,
            filterType: 'all',
            filterTypeName: null,
            location: {
                id: null,
                name: '',
                city: '',
                state: '',
                test: null,
            },
            reportsDataProcessed: false,
            reportsSummariesComplete: false,
            selectedEndDate: null,
            selectedOffset: offsetDefault,
            selectedStartDate: null,
            summariesComplete: false,
            system: system,
            totalFiltersAvailable: 0,
        };
    }

    /**
     * Convert Dates to visual display
     *
     * @param selectedStartDate
     * @param selectedEndDate
     * @return {string}
     */
    displaySelectedDates(selectedStartDate, selectedEndDate) {
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        let startDate = new Date(selectedStartDate + 'T00:00:00');
        let endDate = new Date(selectedEndDate + 'T00:00:00');
        let startDateStr = startDate.toLocaleDateString('en-US', options);
        let endDateStr = endDate.toLocaleDateString('en-US', options);

        return (
            'Date Range: ' + startDateStr + ' through ' + endDateStr
        )
    }

    /**
     * Handle event props from DateRangeFilter
     *
     * @param type
     * @param value
     */
    handleDateRangeFilterSelect = (type, value) => {
        let updatedState = {
            summariesComplete: false,
            isFilterReadyToSubmit: false,
            filterChoiceFirst: null,
            filterChoiceSecond: null,
            filterType: 'all',
            filterTypeName: null,
        };

        switch (type) {
            case 'start_date':
                updatedState.selectedStartDate = value;
                break;
            case 'end_date':
                updatedState.selectedEndDate = value;
                break;
            case 'offset':
                updatedState.selectedOffset = value;
                break;
            default:
                return;
        }

        this.setState(updatedState);
    };


    /**
     * Handle event for Sales Summary Filter type selection
     *
     * @param type
     */
    handleFilterTypeSelect = (type) => {
        if (type.id !== this.state.filterType) {
            this.setState({
                filterChoiceFirst: null,
                filterChoiceSecond: null,
                filterType: type.id,
                filterTypeName: type.name,
                summariesComplete: false,
                totalFiltersAvailable: 0
            });
        }
    };

    /**
     * Handle event for Sales Summary Filter selection
     *
     * @param firstChoice
     * @param secondChoice
     */
    handleFilterOptionSelect = (firstChoice, secondChoice) => {
        let filterChoiceFirst = null;
        if (firstChoice) {
            filterChoiceFirst = firstChoice.toString();
        }
        if (secondChoice === 'none') {
            this.setState({
                filterChoiceFirst: filterChoiceFirst,
                filterChoiceSecond: null,
                summariesComplete: (filterChoiceFirst === this.state.filterChoiceFirst),
                totalFiltersAvailable: 1
            });
        } else {
            this.setState({
                filterChoiceFirst: filterChoiceFirst,
                filterChoiceSecond: secondChoice,
                summariesComplete: (secondChoice === this.state.filterChoiceSecond),
                totalFiltersAvailable: 2
            });
        }
    };

    /**
     * Handle event props for Sales Summary data processing
     *
     * @param reportSet
     */
    handleDataProcessed = (reportSet) => {
        if (reportSet === 'bihourly') {
            this.setState({
                bihourlyDataProcessed: true
            }, () => {
                this.checkDataProcessing();
            });
        }
        if (reportSet === 'reports') {
            this.setState({
                reportsDataProcessed: true
            }, () => {
                this.checkDataProcessing();
            });
        }
    };

    /**
     * Check that all report sets have completed their data processing
     *
     */
    checkDataProcessing = () => {
        const {
            bihourlyDataProcessed,
            reportsDataProcessed
        } = this.state;

        if (bihourlyDataProcessed && reportsDataProcessed) {
            this.setState({
                dataProcessed: true
            });
        }
    };

    /**
     * Handle event props for Sales Summary table collections completion
     *
     * @param reportSet
     * @param isComplete
     */
    handleSummariesComplete = (reportSet, isComplete) => {
        if (reportSet === 'bihourly') {
            this.setState({
                bihourlySummariesComplete: isComplete
            }, () => {
                this.checkSummaryCompletion();
            });
        }
        if (reportSet === 'reports') {
            this.setState({
                reportsSummariesComplete: isComplete
            }, () => {
                this.checkSummaryCompletion();
            });
        }
    };


    handleDateRangeSubmit = () => {
        this.setState({
            isFilterReadyToSubmit: true,
        });
    };

    /**
     * Check that all report sets have completed their table generation
     *
     */
    checkSummaryCompletion = () => {
        const {
            bihourlySummariesComplete,
            reportsSummariesComplete
        } = this.state;

        if (bihourlySummariesComplete && reportsSummariesComplete) {
            this.setState({
                summariesComplete: true
            });
        }
    };

    render() {
        const {
            dataProcessed,
            isFilterReadyToSubmit,
            filterChoiceFirst,
            filterChoiceSecond,
            filterType,
            filterTypeName,
            selectedEndDate,
            selectedStartDate,
            selectedOffset,
            summariesComplete,
            system,
            totalFiltersAvailable,
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Sales Summary Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A Sales Summary Report assembles six reports:</p>
                    <ul>
                        <li>Totals and averages by Location</li>
                        <li>Top 10 Products purchased and returned</li>
                        <li>Top 10 Categories purchased and returned</li>
                        <li>Bihourly averages for the specified date range</li>
                    </ul>
                    <p>Select a Date Range and Time Zone Offset to generate Reports. Then select a secondary filter
                        to further specify results.</p>
                </span>
            );
        };

        let showFilterPrompt = false;
        let showLoading = !!(selectedStartDate && selectedEndDate && selectedOffset && isFilterReadyToSubmit && !summariesComplete);
        if (filterType && filterType !== 'all') {
            if (totalFiltersAvailable === 2 && (!filterChoiceFirst || !filterChoiceSecond)) {
                showFilterPrompt = true;
                showLoading = false;
            } else if (!filterChoiceFirst) {
                showFilterPrompt = true;
                showLoading = false;
            }
        }
        let filterPromptName = (filterTypeName) ? ' for ' + filterTypeName.substr(3) : '';

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Start Date, End Date, Time Zone) */}
                        <DateRangeFilterWithSubmit
                            onSelectStartDate={this.handleDateRangeFilterSelect}
                            onSelectEndDate={this.handleDateRangeFilterSelect}
                            onSelectOffset={this.handleDateRangeFilterSelect}
                            onSubmit={this.handleDateRangeSubmit}
                            label="Submit"
                        />

                        {/* Secondary Filters */}
                        {dataProcessed && isFilterReadyToSubmit &&
                            <SecondaryFilter
                                startDate={selectedStartDate}
                                endDate={selectedEndDate}
                                offset={selectedOffset}
                                resource={filterResources.SalesSummaryFilterByItems}
                                onFilterTypeSelect={this.handleFilterTypeSelect}
                                onFilterChoiceSelect={this.handleFilterOptionSelect}
                                showLoading={showLoading}
                            />
                        }

                        {/* Print Header */}
                        {selectedStartDate && selectedEndDate &&
                            <ReportHeaderState
                                reportType="Sales Summary Report"
                            />
                        }

                        {/* Prompt Messaging */}
                        {showFilterPrompt &&
                            <div className="loader-container">
                                <h4>Please complete a Secondary Filter{filterPromptName}.</h4>
                            </div>
                        }

                        {/* Progress */}
                        {showLoading &&
                            <div className="loader-container">
                                <h4>Generating Reports...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                        }

                        {/* Sales Summary Report Content */}
                        {selectedStartDate && selectedEndDate && selectedOffset && isFilterReadyToSubmit &&
                            <div>

                                {/* Report Header, Loader, and messaging */}
                                <div className="report-header">
                                    <div className="btn-print-container report-header-button-container">
                                        <ReactToPrint
                                            trigger={() =>
                                                <RaisedButton
                                                    primary
                                                    type="button"
                                                    label="Print Report"
                                                    style={styles.button}
                                                />
                                            }
                                            content={() => this.printReportRef}
                                        />
                                    </div>
                                    <h2 className="report-header-title">Sales Summary Reports</h2>
                                    <p>
                                        {this.displaySelectedDates(selectedStartDate, selectedEndDate)}
                                    </p>
                                    {filterType && filterTypeName &&
                                        <p>
                                            Filtered {filterTypeName}: {filterChoiceFirst}
                                            {filterChoiceSecond &&
                                                <span> - {filterChoiceSecond}</span>
                                            }
                                        </p>
                                    }
                                </div>

                                {/* Summary Report Collection */}
                                <SalesSummaryReportSet
                                    startDate={selectedStartDate}
                                    endDate={selectedEndDate}
                                    filterChoiceFirst={filterChoiceFirst}
                                    filterChoiceSecond={filterChoiceSecond}
                                    filterType={filterType}
                                    offset={selectedOffset}
                                    onDataProcessed={this.handleDataProcessed}
                                    onSummariesComplete={this.handleSummariesComplete}
                                    system={system}
                                    totalFiltersAvailable={totalFiltersAvailable}
                                />

                                {/* Bihourly Summary Report Collection */}
                                <SalesSummaryBihourlyReportSet
                                    startDate={selectedStartDate}
                                    endDate={selectedEndDate}
                                    filterChoiceFirst={filterChoiceFirst}
                                    filterChoiceSecond={filterChoiceSecond}
                                    filterType={filterType}
                                    offset={selectedOffset}
                                    onDataProcessed={this.handleDataProcessed}
                                    onSummariesComplete={this.handleSummariesComplete}
                                    system={system}
                                    totalFiltersAvailable={totalFiltersAvailable}
                                />

                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/SalesSummaryReports.js